import React, { useState } from 'react'
import { Box, Collapse, TextField, Stack, Grid, Checkbox, Typography, Table, TableBody, TableHead, TableRow, TableCell, Button, IconButton, InputAdornment, Dialog, DialogContent, DialogTitle, DialogActions, Divider, Autocomplete } from '@mui/material'
import FindInPageIcon from '@mui/icons-material/FindInPage';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SearchIcon from '@mui/icons-material/Search';
import { Api } from '../../../components/api'
import { useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

export default function CreateGroupPermission({ onGet, account }) {
    const { cocode, cogcode, c_coname } = account;

    const [open, setOpen] = useState(false)
    const [group, setGroup] = useState({
        "cogcode": cogcode,
        "cocode": cocode,
        "c_coname": c_coname,
        "groupid": "",
        "groupname": ""
    })


    const onHandleOpen = () => {
        setOpen(true)
    }
    const onHandleClose = () => {
        setOpen(false)
        setGroup({
            "cogcode": cogcode,
            "cocode": cocode,
            "c_coname": c_coname,
            "groupid": "",
            "groupname": ""
        })
    }

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const handleClickVariant = (message, variant) => {
        enqueueSnackbar(message, { variant: variant, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, autoHideDuration: 1000 });

    };

    const handleOnChange = (e) => {
        const { name, value } = e.target
        setGroup(e => {
            return {
                ...e,
                [name]: value
            }
        })
    }

    const onSubmit = () => {
        const data = JSON.stringify({
            // ...values,
            ...group,
            "groupid": (`${group.groupid}.${c_coname}`).toLowerCase()
        });
        Api.post(`v0/if/Permission_groups`, data, { headers: { CompanyGroup: cogcode } })
            .then((res) => {
                onHandleClose()
                handleClickVariant("บันทึกสำเร็จ", "success")
                onGet()
                // console.log('res', res)
            })
            .catch((err) => {
                handleClickVariant("บันทึกไม่สำเร็จ", "error")
                onHandleClose()
                console.log('err', err)
            })
    }

    return (
        <div>
            <IconButton onClick={onHandleOpen} ><PostAddOutlinedIcon /></IconButton>
            <Dialog
                open={open}
                maxWidth="sm"
                fullWidth={true}
                onClose={onHandleClose}
                slotProps={{
                    backdrop: {
                        style: {
                            background: "#a7d8de", opacity: 0.2
                        }
                    }
                }}
            >
                <DialogTitle>สร้างกลุ่มสิทธิ์การใช้งาน</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onHandleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Box sx={{ padding: "10px" }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <TextField size="small" label="groupid" fullWidth name="groupid" value={group.groupid} onChange={handleOnChange} />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextField size="small" label="groupname" fullWidth name="groupname" value={group.groupname} onChange={handleOnChange} />
                            </Grid>
                            <Grid item xs={12}>
                                <Stack direction="row" spacing={1} marginBottom="10px" justifyContent="center">
                                    <Button size="small" variant="contained" onClick={onSubmit}>บันทึก</Button>
                                    <Button size="small" variant="contained" onClick={onHandleClose}>ยกเลิก</Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    )
}
